import { createApp } from 'vue';
import TtfToWoffConverter from '@/Components/TtfToWoffConverter.vue';
import '@styles/app.css';

createApp(TtfToWoffConverter).mount('#ttf-to-woff-converter');
